import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setProvider,
  setSlots, //setSlots
} from "./slot.slice";
import { SlotAction } from "./typing/slot.enum";
import { SlotsService } from "../../../services/slots/slots.service";
import { IStore } from "../../typing/interface";
import { IStoreProvider, IStoreSlot } from "./typing/slot.interface";

export const getSlots = createAsyncThunk(
  SlotAction.GET_SLOTS,
  async (_, { getState, dispatch }) => {
    try {
      const slotsService = new SlotsService();
      const response = await slotsService.fetchSlots();
      if (response.error || !response.result) {
        throw new Error(response.error);
      }
      // dispatch(setSlots(response.result));

      return response.result;
    } catch (error) {
      if (error instanceof Error) {
        console.log(error.message);
      }
    }
  }
);
export const getTSlots = createAsyncThunk<
  | {
      games: IStoreSlot[];
      count: number;
    }
  | undefined,
  {
    [key: string]: boolean | string | number | null | undefined;
    page: number;
    provider: number | undefined;
    attribute: string;
    name?: string | null | undefined;
  },
  { state: IStore }
>(SlotAction.GETT_SLOTS, async (_, { getState, dispatch, rejectWithValue }) => {
  try {
    const { page, provider, name, attribute, ...filter } = _;
    const slotsService = new SlotsService();
    const response = await slotsService.fetchhSlots({
      ...filter,
      page,
      provider,
      name,
    });
    if (response.error || !response.result) {
      throw new Error(response.error);
    }
    dispatch(setSlots({ attribute, ...response.result }));
    return response.result;
  } catch (error) {
    const { attribute } = _;
    dispatch(setSlots({ attribute, games: [], count: 0 }));
  }
});
export const getProviders = createAsyncThunk<
  IStoreProvider[],
  {
    [key: string]: boolean | string | number | null | undefined;
    section: "main" | "slots" | "live" | "crash";
  },
  { state: IStore }
>(SlotAction.GET_PROVIDERS, async (_, { getState, dispatch }) => {
  try {
    const { section } = _;
    const slotsService = new SlotsService();
    const response = await slotsService.fetchProviders(section);
    if (response.error || !response.result) {
      throw new Error(response.error);
    }
    dispatch(setProvider({ section, providers: response.result }));
    return response.result;
  } catch (error) {
    return [];
  }
});

export const verifyRestrictions = createAsyncThunk(
  SlotAction.VERIFY,
  async (_: { gameId: number; is_demo: boolean }) => {
    const slotsService = new SlotsService();
    const { gameId, is_demo } = _;
    const { result, error } = await slotsService.verifyRestrictions(
      gameId,
      is_demo
    );
    if (error) {
      return error.response.data;
    }
    if (result) {
      return result;
    }
  }
);
export const exitGame = createAsyncThunk(
  SlotAction.EXIT_GAME,
  async (game: string | undefined) => {
    const slotsService = new SlotsService();
    const { result, error } = await slotsService.exitGame(game);
    if (error) {
      return error.response.data;
    }
    if (result) {
      return result;
    }
  }
);
